module.exports = __webpack_public_path__ + "static/media/TRIAL-1-if-wrong.0263ddb5.mp3";